// Regexp for spaces and &nbsp
import { QA_DIRECTIVE_NAME } from '@zyro-inc/site-modules/constants';

const regexpToReplace = /\s|&nbsp;/g;

export const formatAttribute = (string) => {
	try {
		return string.replaceAll(regexpToReplace, '').toLowerCase();
	} catch {
		return string;
	}
};

const setDataQA = (element, binding) => {
	// eslint-disable-next-line no-param-reassign
	element.dataset[QA_DIRECTIVE_NAME] = formatAttribute(binding.value);
};

export const dataQADirective = {
	bind: (element, binding) => setDataQA(element, binding),
};
